import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Select from "react-select";
import { Link } from "react-router-dom";
import FreeImage from "../assests/freeweb.webp";
import PreImage from "../assests/white_img.webp";
import ProImage from "../assests/yelllow_img.webp";
import { ScaleLoader } from "react-spinners";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import authService from "../services/authservices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const Upgrade = () => {
  const [coinType, setCoinType, coinTyperef] = useState("usdt");
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
  }, [i18nextLngs]);

  const options = [
    {
      value: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      label: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
    {
      value: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      label: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
    {
      value: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      label: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
  ];

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#f9f9f9",
      border: "1px solid #ccc",
      padding: "4px",
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: "#fff",
      backgroundColor: isFocused ? "#292b31" : "#181a20",
      cursor: "pointer",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#000",
    }),
  };

  useEffect(() => {
    getPlan();
    getPlanDetails();
  }, [0]);

  const [getplan, setGetplan] = useState([]);
  const [planDetails, setPlanDetails] = useState([]);
  const [pageLoader, setpageLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [freemiumActive, setFreemiumActive] = useState(null);
  const [premiumActive, setPremiumActive] = useState(null);
  const [promiumActive, setPromiumActive] = useState(null);
  const [planLoader, setplanLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [premiumContent, setPremiumContent] = useState(null);
  const [Freeplan, setFreeplan] = useState(false);
  const [eliteActive, setEliteActive] = useState(null);
  const [discountCode, setdiscountCode] = useState("");
  const [discountAmount, setdiscountAmount] = useState("");

  useEffect(() => {
    const href = window.location.pathname;
    const url = href.split("upgrade/")[1];
    //  console.log(url);
    setdiscountCode(url ? url : "");
  }, []);

  const getPlan = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await authService.getPlan(token);
      if (response.status) {
        setGetplan(response.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getPlanDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await authService.getPlanDetails(token);
      setLoading(false);
      console.log(response.data, "response.data==");
      if (response.data && Array.isArray(response.data)) {
        const activePlans = {
          freemium: false,
          premium: false,
          promium: false,
          elite: false,
        };

        response.data.forEach((plan) => {
          if (plan.subscriptionName === "Freemium" && plan.isActive) {
            activePlans.freemium = true;
          } else if (plan.subscriptionName === "Premium" && plan.isActive) {
            activePlans.premium = true;
          } else if (plan.subscriptionName === "Promium" && plan.isActive) {
            activePlans.promium = true;
          } else if (
            plan.subscriptionName === "Elite Trader" &&
            plan.isActive
          ) {
            activePlans.elite = true;
          }
        });

        // Update state at once for better performance
        setFreemiumActive(activePlans.freemium);
        setPremiumActive(activePlans.premium);
        setPromiumActive(activePlans.promium);
        setEliteActive(activePlans.elite);

        const freemiumActivated = response.data.some(
          (plan) =>
            plan.subscriptionName === "Freemium" &&
            plan.isFreemiumActivated === true
        );

        localStorage.setItem("freemiumActivated", freemiumActivated);
        setPlanDetails(response.data);
        setFreeplan(response.free_plan);
      } else {
        setPlanDetails([]);
        localStorage.setItem("freemiumActivated", false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching plan details:", error);
    }
  };

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(
      <div className="toast-ml">
        <h4 className="toast-title">Success!</h4>
        <p className="toast-message">{message}</p>
      </div>
    );
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(
      <div className="toast-ml">
        <h4 className="toast-title">Error!</h4>
        <p className="toast-message">{message}</p>
      </div>
    );
  };

  const handleClose = () => {
    setShow(false);
    setPremiumContent(null);
  };

  const handleShow = async (planName, subscription) => {
    // console.log(subscription, "subscription");
    switch (planName) {
      case "Premium":
        setPremiumContent(subscription);
        break;
      case "Freemium":
        setPremiumContent(subscription);
        break;
      case "Promium":
        setPremiumContent(subscription);
        break;
      case "Elite Trader":
        setPremiumContent(subscription);
        break;
      default:
        break;
    }
    setShow(true);
    if (discountCode) {
      const getDiscount = await authService.getDiscountData(discountCode);
      if (getDiscount.status) {
        setdiscountAmount(getDiscount.data);
      }
    }
  };

  const PlanUpgrade = async (data) => {
    try {
      setLoading(true);
      var obj = {
        subid: data._id,
        discountAmount: discountAmount,
        discountCode: discountCode,
      };
      // console.log(obj);
      const response = await authService.planUpgrade(obj);
      if (response.status) {
        setLoading(false);
        showsuccessToast(response.Message);
        getPlanDetails();
      } else {
        showerrorToast(response.Message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error, "-----------------");
    }
    setShow(false);
  };
  const [faqs, setFaqs] = useState({});

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await authService.getFaq();
        if (response.status) {
          const withdrawFaqs = response.data.filter(
            (faq) => faq.type === "Upgrade"
          );
          setFaqs(withdrawFaqs);
        } else {
          console.error("Failed to fetch FAQs");
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
  }, []);

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const SubscriptionCard = ({ subscription, freemiumActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Freemium":
        return (
          <div className="free_upgradesec">
            <div className="free_version_section">
              {freemiumActive && <div className="activated_tag">Activated</div>}
              <img src={FreeImage} alt="Loading..." />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>Free</h1>
              {/* <p style={{visibility:'hidden'}} className="free_tag">Free for 6 months </p> */}
              <p className="free_tag">Free for {subscription.subdays} Days </p>
              <div className="activate_btn">
                <button
                  disabled={freemiumActive || Freeplan}
                  onClick={() => handleShow("Freemium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">Profit Split:</span>{" "}
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Referral one time reward ({subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const SubscriptionCardtwo = ({ subscription, premiumActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Premium":
        return (
          <div className="perimium_upgradesec">
            <div className="premium_version_section">
              {premiumActive && (
                <div className="activated_tag_pre">Activated</div>
              )}
              <img src={PreImage} className="premium_img" alt="Loading..." />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>
                {parseFloat(subscription.subscriptionAmount).toFixed(2)}{" "}
                <span className="currency_name">
                  {subscription.subscriptionCurrency}
                </span>
                <span className="premium_cost">/month</span>
              </h1>
              <p className="free_tag" style={{ visibility: "hidden" }}>
                Free for {subscription.subdays} Months
              </p>
              <div className="activate_btn_white">
                <button
                  disabled={premiumActive}
                  onClick={() => handleShow("Premium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  {/* <p>{capitalizeFirstLetter(subscription.Exchanges)}</p> */}
                  <p>
                    <span className="header_details_list_pre">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list_pre">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Profit Split:
                    </span>
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Referral one time reward (
                      {subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div>

              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const SubscriptionCardthree = ({ subscription, promiumActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Promium":
        return (
          <div className="extrapre_upgradesec">
            <div className="pro_version_section">
              {promiumActive && (
                <div className="activated_tag_pro">Activated</div>
              )}
              <img
                src={ProImage}
                className="premium_imgcost"
                alt="Loading..."
              />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>
                {parseFloat(subscription.subscriptionAmount).toFixed(2)}
                <span className="currency_name">
                  {" "}
                  {subscription.subscriptionCurrency}
                </span>
                <span className="premium_cost">/month</span>
              </h1>
              <p className="free_tag" style={{ visibility: "hidden" }}>
                <span className="free_plan_pro">Free</span> for{" "}
                {subscription.subdays} Months{" "}
              </p>
              <div className="activate_btn_pro">
                <button
                  disabled={promiumActive}
                  onClick={() => handleShow("Promium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                  {/* <p>{capitalizeFirstLetter(subscription.Exchanges)}</p> */}
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list_pro">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Profit Split:
                    </span>
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral one time reward (
                      {subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div>

              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const SubscriptionCardfour = ({ subscription, eliteActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Elite Trader":
        return (
          <div className="extrapre_upgradesec">
            <div className="pro_version_section">
              {eliteActive && (
                <div className="activated_tag_pro">Activated</div>
              )}
              <img
                src={ProImage}
                className="premium_imgcost"
                alt="Loading..."
              />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>
                {parseFloat(subscription.subscriptionAmount).toFixed(2)}
                <span className="currency_name">
                  {" "}
                  {subscription.subscriptionCurrency}
                </span>
                <span className="premium_cost">/month</span>
              </h1>
              <p className="free_tag" style={{ visibility: "hidden" }}>
                <span className="free_plan_pro">Free</span> for{" "}
                {subscription.subdays} Months{" "}
              </p>
              <div className="activate_btn_pro">
                <button
                  disabled={promiumActive}
                  onClick={() => handleShow("Promium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                  {/* <p>{capitalizeFirstLetter(subscription.Exchanges)}</p> */}
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list_pro">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Profit Split:
                    </span>
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral one time reward (
                      {subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div>

              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <>
        <Header />
      </>

      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <div className="upgrade_header">
                <h3 className="profile_span">
                  <span className="upgrade_text">{t("Upgrade")} </span>
                  <span className="upgrade_profilespan">
                    {t("YourProfile")}
                  </span>
                </h3>
                <p>{t("EmpowerYourTradingWithBinarge")}</p>
              </div>
              <div className="row mt-lg-1 mt-2 g-4 justify-content-center">
                {loading ? (
                  <div className="loader_main loader_mainChange">
                    <ScaleLoader color="#20A1FD" height={10} width={3} />
                    <p>{t("Loading")}</p>
                  </div>
                ) : (
                  <>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCard
                          key={subscription._id}
                          subscription={subscription}
                          freemiumActive={freemiumActive}
                        />
                      ))}
                    </div>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCardtwo
                          key={subscription._id}
                          subscription={subscription}
                          premiumActive={premiumActive}
                        />
                      ))}
                    </div>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCardthree
                          key={subscription._id}
                          subscription={subscription}
                          promiumActive={promiumActive}
                        />
                      ))}
                    </div>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCardfour
                          key={subscription._id}
                          subscription={subscription}
                          eliteActive={eliteActive}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
              <Modal
                className="modal_section upgrade_modal_section"
                centered
                show={show}
                onHide={handleClose}
                animation={false}
              >
                <Modal.Header closeButton className="upgrad_modal_header">
                  <Modal.Title>{t("ConfirmPlanUpgrade")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="upgrad_modal_body">
                  <div>
                    <h5
                      className={
                        premiumContent?.subscriptionName === "Premium"
                          ? "premium-header "
                          : premiumContent?.subscriptionName === "Promium"
                          ? "promium-header "
                          : "freemium-header "
                      }
                    >
                      {premiumContent?.subscriptionName}
                    </h5>
                    <p>
                      <strong className="stragte_head">
                        {t("BotsStrategies")}:
                      </strong>{" "}
                      {premiumContent?.Strategies}
                    </p>
                    <p className="upgrade_text_modal">
                      {t("UpgradingToThe")}{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName}
                      </strong>{" "}
                      {t("PlanWillCostYou")}{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Elite Trade"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName === "Premium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                          : premiumContent?.subscriptionName === "Promium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                          : premiumContent?.subscriptionName === "Elite Trader"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                          : "Free"}
                      </strong>
                      . {t("PleaseConfirmYourChoice")}
                    </p>
                    {discountCode ? (
                      <>
                        <div className="reg_inner_small">
                          <span className="register_spans upgrad_md_label">
                            {t("DiscountCode")}
                          </span>
                          <input
                            type="text"
                            name="email"
                            placeholder={t("EnterTheEmailAddress")}
                            className="reg_input"
                            value={discountCode}
                          />
                          <p className="upgrad_modal_content">
                            {t("GreatNews")} <strong>${discountAmount}</strong>.
                            {premiumContent ? (
                              <>
                                {" "}
                                {t("YouOnlyNeedToPay")}{" "}
                                <strong>
                                  $
                                  {premiumContent.subscriptionAmount -
                                    discountAmount}
                                </strong>{" "}
                                {t("forYourSubscription")}
                              </>
                            ) : (
                              <> {t("YourFinalPrice")}.</>
                            )}
                          </p>
                        </div>
                        {/* <p className="upgrad_modal_content">
                      Great news! You've received a discount of <strong>${discountAmount}</strong>.
                      {premiumContent ? (
                        <> You only need to pay <strong>${premiumContent.subscriptionAmount - discountAmount}</strong> for your subscription.</>
                      ) : (
                        <> Your final price will be calculated once you select a plan.</>
                      )}
                    </p>  */}
                      </>
                    ) : (
                      ""
                    )}

                    {/* <h5 
          className={ premiumContent?.subscriptionName === "Premium"
                ? "premium-header mt-4"
                : premiumContent?.subscriptionName === "Promium"
                ? "promium-header mt-4"
                : "freemium-header mt-4" }>
                      {premiumContent?.subscriptionName}
                    </h5>
                    <p>
                      <strong className="stragte_head">Bots Strategies:</strong>{" "}
                      {premiumContent?.Strategies}
                    </p>
                    <p className="upgrade_text_modal">
                      Upgrading to the{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName}
                      </strong>{" "}
                      plan will cost you{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Elite Trade"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName === "Premium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"

                          : premiumContent?.subscriptionName === "Promium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount : "Free"

                        : premiumContent?.subscriptionName === "Elite Trader"
                        ? premiumContent?.free_status == "no"
                          ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                            
                          : "Free"}
                      </strong>
                      . Please confirm your choice.
                    </p> */}
                  </div>
                </Modal.Body>

                <div className="upgrad_modal_footer">
                  {loading == true ? (
                    <Button variant="primary" className="upgrade_btn">
                      {t("Loading")}
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      className="upgrade_btn"
                      onClick={() => PlanUpgrade(premiumContent)}
                    >
                      {t("ConfirmUpgrade")}
                    </Button>
                  )}
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upgrade;
